import React from 'react'
import { connect } from 'react-redux'
import SectionActions from '../../Redux/SectionRedux'

class DeleteSubSection extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  _delete = (uuid) => {
    let data = { uuid }
    this.props.deleteSubSection(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 500)
  }

  render () {
    return (
      <section style={{ width: '40vw' }}>
        <div className='title-block'>
          <h3 className='title'>Delete Subsection</h3>
        </div>
        <div className='text-center'>
          <h4>Delete this section?</h4>
          {this.props.detail.title_id} / {this.props.detail.title_en}
        </div>
        <div className='row'>
          <div className='col-12 text-right'>
            <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
            <button type='submit' className='btn btn-danger' onClick={() => this._delete(this.props.detail.id)}>Confirm</button>
          </div>
        </div>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  section: state.section
})

const dispatchToProps = (dispatch) => ({
  deleteSubSection: (data) => dispatch(SectionActions.deleteSubSectionRequest(data))
})

export default connect(stateToProps, dispatchToProps)(DeleteSubSection)



// WEBPACK FOOTER //
// ./src/Containers/Section/DeleteSubSection.js